module.exports = ".ck.ck-character-info{display:flex;justify-content:space-between}"